import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false
import Meta from 'vue-meta'
Vue.use(Meta)
import router from './router'
// 导入axios
import http from './request'
Vue.prototype.$http = http
// 导入工具函数
import utils from '@/utils/utils'
Vue.prototype.utils = utils
// 重置css
import './assets/css/reset.css'
import './assets/css/global.css'
// 导入element ui
import './utils/element'
import 'element-ui/lib/theme-chalk/base.css'
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
